import { render } from "./huangpaiHongpaiJiaoqiu.vue?vue&type=template&id=5465e0f9&scoped=true"
import script from "./huangpaiHongpaiJiaoqiu.vue?vue&type=script&lang=js"
export * from "./huangpaiHongpaiJiaoqiu.vue?vue&type=script&lang=js"

import "./huangpaiHongpaiJiaoqiu.vue?vue&type=style&index=0&id=5465e0f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5465e0f9"]])

export default __exports__